if (
  window.location.pathname === "/cart" ||
  window.location.pathname.startsWith("/pages/our") ||
  window.location.pathname.startsWith("/blogs") ||
  window.location.pathname.startsWith("/products") ||
  window.location.pathname.startsWith("/blog") ||
  window.location.pathname.startsWith("/policies") ||
  window.location.pathname.startsWith("/pages")
) {
  // Select the header element
  const headerElement = document.querySelector(".header--custom");
  // Add a class to the header element
  if (headerElement) {
    headerElement.style.position = "relative";
    headerElement
      .querySelectorAll(".header__menu-item")
      .forEach((headerMenuItem) => {
        headerMenuItem.querySelector("span").style.color =
          "rgba(var(--color-foreground), 0.85)";
      });
    headerElement.querySelectorAll("svg").forEach((svg) => {
      svg.style.color = "rgba(var(--color-foreground), 0.85)";
    });
    headerElement.querySelectorAll(".header__icon").forEach((headerIcon) => {
      headerIcon.querySelector(".icon").style.color =
        "rgba(var(--color-foreground).85)";
    });
  }
} else {
}
